<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="operation_data">
      <vx-card title="Closest Person/Company" class="mb-base">
        <template>
          <div id="data-list-list-view" class="data-list-container">
            <vs-table ref="table" :data="operation_data">
              <template slot="thead">
                <vs-th sort-key="username">#</vs-th>
                <vs-th sort-key="username">Category Operation</vs-th>
                <vs-th sort-key="username">Category Product</vs-th>
                <vs-th sort-key="username">Volume (m3)</vs-th>
                <vs-th>Copy Product</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>#{{ tr.id }}</vs-td>
                    <vs-td>{{ tr.label }}</vs-td>
                    <vs-td>{{ tr.category_name }}</vs-td>
                    <vs-td>{{ tr.volume }}</vs-td>
                    <vs-td>
                      <feather-icon
                        icon="CopyIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click="copyProduct(tr.id)"/>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";

export default {
  data() {
    return {
      operation_data: null,
      data: {},
      user_not_found: false,
      idoperationto:null,
      idperson:null
    };
  },
  methods: {
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    },
    
    async loadOperation() {
      axios.get('/operation/quickcopy/'+this.idperson)
        .then((response) => {
          this.operation_data = [...response.data]
        })
    },
    async copyProduct(idoperationfrom) {
      axios.get('/operation/product_copy/'+idoperationfrom+'/'+this.idoperationto)
        .then((response) => {
          console.log(response.data)
          if (response.data === 'GOOD')
          {
            this.$router.push({ path: "/sale-edit/" + this.idoperationto });
              this.$vs.notify({
                color: 'success',
                title: '',
                text: 'Products successfuly copied!'
              })
          }
          else
          { 
              this.$vs.notify({
                color: 'danger',
                title: '',
                text: 'Minimum one Product already exist!'
              })
          }
        }).catch(error => {
              this.$vs.notify({
                color: 'danger',
                title: '',
                text: 'Minimum one Product already exist!'
              })

        })
    }
  },
  created() {
    this.idperson = this.$route.params.idperson
    this.idoperationto = this.$route.params.idoperationto
    this.loadOperation ()
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}
/*
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}
*/
// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
/*
.vs-chip-success {
  background: rgba(var(--vs-success), 0.15);
  color: rgba(var(--vs-success), 1) !important;
  font-weight: 500;
}
.vs-chip-warning {
  background: rgba(var(--vs-warning), 0.15);
  color: rgba(var(--vs-warning), 1) !important;
  font-weight: 500;
}
.vs-chip-danger {
  background: rgba(var(--vs-danger), 0.15);
  color: rgba(var(--vs-danger), 1) !important;
  font-weight: 500;
}*/
</style>
